import {
    useEffect,
    useState
} from 'react';

const useTooltip = (ref: any) => {
    const [ tooltipVisible, setTooltipVisible ] = useState(false);

    const handleHover = () => setTooltipVisible(true);

    const handleLeave = () => setTooltipVisible(false);

    useEffect(() => {
        const { current: tooltipTrigger } = ref;

        if (tooltipTrigger) {
            tooltipTrigger.addEventListener('mouseenter', handleHover);
            tooltipTrigger.addEventListener('mouseleave', handleLeave);


            return () => {
                tooltipTrigger.removeEventListener('mouseenter', handleHover);
                tooltipTrigger.removeEventListener('mouseleave', handleLeave);
            };
        }
    }, [ ref ]);

    return tooltipVisible;
};

export default useTooltip;
